import React from 'react';
import SkeletonWrapper from '../../../shared/components/skeleton/SkeletonWrapper';
import Nbsp from '../../../shared/components/Nbsp';

/**
 * @typedef {object} NumberOfLicensesProps
 * @property {number|string} [numberOfTotalLicenses]
 * @property {number|string} [numberOfAssignedLicenses]
 * @property {boolean} loading
 */

/**
 * @param {NumberOfLicensesProps} props
 */
const NumberOfLicenses = props => {
  const {
    numberOfTotalLicenses = 'N/A',
    numberOfAssignedLicenses = 'N/A',
    loading = false
  } = props;

  return (
    <p className='licenses'>
      Number of licenses:
      <Nbsp />
      <SkeletonWrapper show={loading}>
        <span>{`${numberOfAssignedLicenses} of ${numberOfTotalLicenses}`}</span>
      </SkeletonWrapper>
    </p>
  );
};

export default NumberOfLicenses;
